export interface IStrongBoxListingBase {
    id: number,
    lastPhysicalInventoryDate?: string,
    lastPhysicalInventoryCount?: number,
    unitsOrderedSinceLastPhysicalInventory: number,
    unitsDeliveredSinceLastPhysicalInventory: number,
    unitsUtilizedSinceLastPhysicalInventory: number,
    quantityOnHand: number,
    minimumInventoryLevel: number,
    isActive: boolean,
    createdByUserId: number,
    createdDate: Date,
    updatedByUserId: number,
    updatedDate: Date,
}

export interface IStrongBoxListing extends IStrongBoxListingBase {
    centerId: number,
    centerAlias: string,
    shippingAddressApprovalDate?: string
    shippingAddressApprovalUserId?: number,
    isShippingAddressCompliant: boolean,
}

export interface IStrongBoxOpoListing extends IStrongBoxListingBase {
    opoId: number,
    opoName: string
}
